import { Grid } from '@mui/material';
import React from 'react';
import { Route, Routes } from 'react-router-dom'; 
import Home from '../pages/home/Home';
import About from '../pages/about/About';
import ProductsAllPages from '../pages/products/ProductsAllPages';
import Blog from '../pages/blog/Blog';
import AllPageContact from '../pages/contactUs/AllPageContact';
import TermsAndConditionAllPages from '../pages/termsAndCondition/TermsAndConditionAllPages';
import PrivacyPolicyAll from '../pages/privacyPolicy/PrivacyPolicyAll';
import Footer from './Footer';
import DownloadAppShowcase from './DownloadAppShowcase';
import Header from './Header';
import ChildSafety from '../pages/childSafety/ChildSafety';
import DataSafety from '../pages/dataSafety/DataSafety';
import AccountDeletion from '../pages/accountDeletion/AccountDeletion';
import ManageAccount from '../pages/manageAccount/ManageAccount';
import MarketingPage from '../pages/marketing/MarketingPage';
import TermsOfService from '../pages/termsOfService/TermsOfService';
import AgeSuitability from '../pages/ageSuitability/AgeSuitability';

// Industry Pages
import LiveIndustry from '../pages/industry/LiveIndustry';
import BusinessIndustry from '../pages/industry/BusinessIndustry';
import GlobalMarketingIndustry from '../pages/industry/GlobalMarketingIndustry';
import AiAssistantIndustry from '../pages/industry/AiAssistantIndustry';
import MediaEditorIndustry from '../pages/industry/MediaEditorIndustry';
import AiFiltersIndustry from '../pages/industry/AiFiltersIndustry';
import EffectsIndustry from '../pages/industry/EffectsIndustry';
import ShootingLocationsIndustry from '../pages/industry/ShootingLocationsIndustry';
import AuditionsIndustry from '../pages/industry/AuditionsIndustry';
import JobsIndustry from '../pages/industry/JobsIndustry';

// Media Services Pages
import FilmStreamingService from '../pages/industry/FilmStreamingService';
import TalentDiscoveryService from '../pages/industry/TalentDiscoveryService';

function PageLink() {
  return (
    <Grid>
       <Header />
      <Routes>
       
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<ProductsAllPages />} />
        <Route path="/features" element={<ProductsAllPages />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<AllPageContact />} />
        <Route path="/termsAndCondition" element={<TermsAndConditionAllPages />} />
        <Route path="/privacyPolicyAll" element={<PrivacyPolicyAll />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/data-safety" element={<DataSafety />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/manage-account" element={<ManageAccount />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/age-suitability" element={<AgeSuitability />} />
        
        {/* Industry Routes */}
        <Route path="/industry/live" element={<LiveIndustry />} />
        <Route path="/industry/business" element={<BusinessIndustry />} />
        <Route path="/industry/global-marketing" element={<GlobalMarketingIndustry />} />
        <Route path="/industry/ai-assistant" element={<AiAssistantIndustry />} />
        <Route path="/industry/own-media-editor" element={<MediaEditorIndustry />} />
        <Route path="/industry/ai-filters" element={<AiFiltersIndustry />} />
        <Route path="/industry/effects" element={<EffectsIndustry />} />
        <Route path="/industry/shooting-locations" element={<ShootingLocationsIndustry />} />
        <Route path="/industry/auditions" element={<AuditionsIndustry />} />
        <Route path="/industry/jobs" element={<JobsIndustry />} />
        
        {/* Media Services Routes */}
        <Route path="/services/film-streaming" element={<FilmStreamingService />} />
        <Route path="/services/talent-discovery" element={<TalentDiscoveryService />} />
      
      </Routes>
          <DownloadAppShowcase />
    </Grid>
  );
}

export default PageLink;
